import { getNonEmptyValuesFromObject } from '../../utils/object';
import type { CustomParamsUser } from './ga4Types';
import { gtagWrapper } from './utils';

/**
 * Tracks GA4 user properties. Only tracks properties that are not empty.
 */
export const trackUserProperties = (params: CustomParamsUser) => {
  const userParams: CustomParamsUser = getNonEmptyValuesFromObject(params);
  if (!Object.keys(userParams).length) {
    return;
  }

  gtagWrapper('set', 'user_properties', userParams);
};
